export default "__VITE_ASSET__CLfcy6eE__"